<template>
    <section class="finance">
        <section class="m-banner">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide>
                    <a href="">
                        <img src="../../assets/images/finance/banner.jpg" alt="">
                        <span>调整退休人员基本养老金工作全面完成 24省份近9800亿</span>
                    </a>
                </swiper-slide>
                <swiper-slide>
                    <a href="">
                        <img src="../../assets/images/finance/banner.jpg" alt="">
                        <span>调整退休人员基本养老金工作全面完成 24省份近9800亿</span>
                    </a>
                </swiper-slide>
                <swiper-slide>
                    <a href="">
                        <img src="../../assets/images/finance/banner.jpg" alt="">
                        <span>调整退休人员基本养老金工作全面完成 24省份近9800亿</span>
                    </a>
                </swiper-slide>
                <div class="swiper-pagination"  slot="pagination"></div>
            </swiper>       
        </section>
        <section class="m-floor m-floor-1">
            <h2 class="m-common">
                <span></span>
                壮观财经
                <a href="javascript:;">更多</a>
            </h2>
            <div class="finance-box">
                <dl @click="enterNews">
                    <dt>
                        <img src="../../assets/images/finance/pic_1.png" alt="">
                    </dt>
                    <dd>
                        <p>从金融市场多元化谈保险从业人员的专业坚守</p>
                        <p>
                            <span>广西新闻网</span>
                            <span>10小时前</span>
                        </p>
                    </dd>
                </dl>
                <dl @click="enterNews">
                    <dt>
                        <img src="../../assets/images/finance/pic_1.png" alt="">
                    </dt>
                    <dd>
                        <p>从金融市场多元化谈保险从业人员的专业坚守</p>
                        <p>
                            <span>广西新闻网</span>
                            <span>10小时前</span>
                        </p>
                    </dd>
                </dl>
                <dl @click="enterNews">
                    <dt>
                        <img src="../../assets/images/finance/pic_1.png" alt="">
                    </dt>
                    <dd>
                        <p>从金融市场多元化谈保险从业人员的专业坚守</p>
                        <p>
                            <span>广西新闻网</span>
                            <span>10小时前</span>
                        </p>
                    </dd>
                </dl>
            </div>
        </section>
        <section class="m-floor m-floor-2">
            <div class="m-ad">
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">    
                </a>
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">
                </a>
            </div>
        </section>
        <section class="m-floor m-floor-3">
            <h2 class="m-common">
                <span></span>
                理财
                <em>火爆热销</em>
            </h2>
            <div class="finance-box">
                <div class="financial">
                    <ul>
                        <li>
                            <a href="">
                                <div class="info">光银现金A</div>
                                <div class="info">
                                    <div class="find left">
                                        <p>365</p>
                                        <p>天</p>
                                    </div>
                                    <div class="find right">
                                        <p>4.1%</p>
                                        <p>参考收益率</p>
                                    </div>
                                </div>
                                <div class="info">
                                    光大银行 | 50000元起
                                </div>
                                <div class="info">发行日期：2019-08-17至2019-08-17</div>
                                <div class="info">
                                    <span>了解详情</span>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="">
                                <div class="info">光银现金A</div>
                                <div class="info">
                                    <div class="find left">
                                        <p>365</p>
                                        <p>天</p>
                                    </div>
                                    <div class="find right">
                                        <p>4.1%</p>
                                        <p>参考收益率</p>
                                    </div>
                                </div>
                                <div class="info">
                                    光大银行 | 50000元起
                                </div>
                                <div class="info">发行日期：2019-08-17至2019-08-17</div>
                                <div class="info">
                                    <span>了解详情</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <a href="">
                                <div class="info">光银现金A</div>
                                <div class="info">
                                    <div class="find left">
                                        <p>365</p>
                                        <p>天</p>
                                    </div>
                                    <div class="find right">
                                        <p>4.1%</p>
                                        <p>参考收益率</p>
                                    </div>
                                </div>
                                <div class="info">
                                    光大银行 | 50000元起
                                </div>
                                <div class="info">发行日期：2019-08-17至2019-08-17</div>
                                <div class="info">
                                    <span>了解详情</span>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="">
                                <div class="info">光银现金A</div>
                                <div class="info">
                                    <div class="find left">
                                        <p>365</p>
                                        <p>天</p>
                                    </div>
                                    <div class="find right">
                                        <p>4.1%</p>
                                        <p>参考收益率</p>
                                    </div>
                                </div>
                                <div class="info">
                                    光大银行 | 50000元起
                                </div>
                                <div class="info">发行日期：2019-08-17至2019-08-17</div>
                                <div class="info">
                                    <span>了解详情</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="m-floor m-floor-4">
            <h2 class="m-common">
                <span></span>
                理财课堂
                <a href="javascript:;">更多</a>
            </h2>
            <div class="finance-box-2">
                <ul>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="m-floor m-floor-5">
            <div class="m-ad">
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">    
                </a>
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">
                </a>
            </div>    
        </section>
        <section class="m-floor m-floor-6">
            <h2 class="m-common">
                <span></span>
                贷款
                <em>正规快捷</em>
            </h2> 
            <div class="finance-box">
                <ul class="loan-type">
                    <li>
                        <a href="">
                            <div class="name n1">速贷</div>
                            <div class="content">简单，快</div>
                            <div class="pic">
                                <img src="../../assets/images/finance/f_1.png" alt="">    
                            </div>
                            <div class="detail">
                                <span>了解详情</span>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="name n2">桂农贷</div>
                            <div class="content">支持三农真不赖</div>
                            <div class="pic">
                                <img src="../../assets/images/finance/f_2.png" alt="">    
                            </div>
                            <div class="detail">
                                <span>了解详情</span>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="name n3">微链贷</div>
                            <div class="content">支持产业放款快</div>
                            <div class="pic">
                                <img src="../../assets/images/finance/f_3.png" alt="">    
                            </div>
                            <div class="detail">
                                <span>了解详情</span>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>   
        </section>
        <section class="m-floor m-floor-7">
            <div class="m-ad">
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">    
                </a>
                <a href="">
                    <img src="../../assets/images/finance/pic_2.png" alt="">
                </a>
            </div>    
        </section>
        <section class="m-floor m-floor-8">
            <h2 class="m-common">
                <span></span>
                贷款课堂
                <a href="javascript:;">更多</a>
            </h2>
            <div class="finance-box-2">
                <ul>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                </ul>
            </div>
        </section>
        <section class="m-floor m-floor-9">
            <h2 class="m-common">
                <span></span>
                保险
                <em>线上办理</em>
            </h2>
            <div class="finance-box">
                <div class="insurance-list">
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                    <a href="">
                        <img src="../../assets/images/finance/pic_4.png" alt="">    
                    </a>
                </div>
            </div>
        </section>
        <section class="m-floor m-floor-10">
            <h2 class="m-common">
                <span></span>
                保险讲堂
                <a href="javascript:;">更多</a>
            </h2>
            <div class="finance-box-2">
                <ul>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                    <li>
                        <div class="pic">
                            <i class="play"></i>
                            <img src="../../assets/images/finance/pic_3.png" alt="">
                        </div>
                        <div class="title">工行南宁分行钱币理财金融大讲堂</div>
                    </li>
                </ul>
            </div>    
        </section>
        <section class="m-floor m-floor-11">
            <h2 class="m-common">
                <span></span>
                广西保险精英
                <a href="javascript:;">更多</a>
            </h2> 
            <div class="finance-box">
                <ul class="elite-list">
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                    <li>
                        <a href="">
                            <div class="pic">
                                <img src="../../assets/images/finance/pic_5.png" alt="">    
                            </div>
                            <div class="name">张三</div>
                            <div class="inst">平安保险精英</div>
                        </a>
                    </li>
                </ul>
            </div>   
        </section>
        <section class="m-floor m-floor-12">
            <ul class="colmun-list">
                <li>
                    <a href="">
                        <img src="../../assets/images/finance/pic_6.png" alt="">    
                    </a>
                </li>
                <li>
                    <a href="">
                        <img src="../../assets/images/finance/pic_7.png" alt="">    
                    </a>
                </li>
            </ul>
        </section>    
    </section>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    data(){
        return{
            swiperOption:{
                pagination: {
                    el: '.swiper-pagination'
                },
                loop: true,
                autoplay: true,
                speed: 1000 
            },
        }
    },
    methods:{
        enterNews(){
            this.$router.push('/')
        }
    },
    components: {
        swiper,
        swiperSlide
    }    
}
</script>

<style lang="less" scoped>
    .m-banner{
        margin-bottom: 0.4rem;
        img{
            width: 100%;
        }
        span{
            display: block;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            height: 1.3rem;
            line-height: 1.3rem;
            background: rgba(0,0,0,0.3);
            color: #fff;
            box-sizing: border-box;
            padding-left: 0.5rem;
            font-size: 0.32rem;
        }   
    }
    .m-floor{
        padding: 0 0.35rem;
    }
    .m-common{
        font-size: 0.55rem;
        color: #000;
        font-weight: bold;
        margin-top: 0.3rem;
        span{
            display: inline-block;
            width: 0.15rem;
            height: 0.55rem;
            border-radius: 0.5rem;
            background: #eeb63e;
            vertical-align: middle;
            margin-right: 0.1rem;
        }
        em{
            display: inline-block;
            font-size: 0.3rem;
            font-weight: normal;
            border: 1px solid #eeb63e;
            color: #eeb63e;
            font-style: normal;
            border-radius: 0.23rem;
            padding: 0 0.1rem;
            margin-left: 0.1rem;
        }
        a{
            float: right;
            display: inline-block;
            border-radius: 0.2rem;
            background: #eeb63e;
            font-size: 0.35rem;
            padding: 0 0.15rem;
            color: #fff;
            margin-top: 0.2rem;
            font-weight: normal;
            height: 0.65rem;
        }
    }
    .finance-box{
        border-radius: 0.3rem;
        box-shadow: 0 0 0.5rem #f4f7fe;
        box-sizing: border-box;
        padding: 0.3rem;
        margin-top: 0.25rem;
        dl{
            display: flex;
            padding-bottom: 0.4rem;
            border-bottom: 1px solid #e5e5e5;
            margin-bottom: 0.4rem;
            &:nth-last-of-type(1){
                border-bottom: none;
                padding-bottom: 0;
            }
            dt{
                img{
                    width: 90%;
                    border-radius: 0.22rem;
                }
            }
            dd{
                p{
                    &:nth-of-type(1){
                        font-size: 0.38rem;
                        font-weight: bold;
                        margin-bottom: 0.2rem;
                    }
                    &:nth-of-type(2){
                        span{
                            margin-right: 0.2rem;
                            color: #6f6f6f;
                            font-size: 0.3rem;
                        }
                    }
                }
            }
        }
        .financial{
            ul{
                padding-bottom: 0.4rem;
                border-bottom: 1px dashed #e6e6e6;
                margin-bottom: 0.35rem;
                display: flex;
                &:nth-last-of-type(1){
                    border-bottom: none;
                    margin-bottom: 0;
                }
            }
            li{
                &:nth-of-type(1){
                    padding-right: 0.4rem;
                    border-right: 1px solid #e6e6e6;
                }
                &:nth-of-type(2){
                    padding-left: 0.4rem;
                }
                a{
                    color: #666;
                }
                .info{
                    margin-bottom: 0.16rem;
                    &:nth-of-type(1){
                        font-size: 0.45rem;
                        color: #000;
                    }
                    &:nth-of-type(2){
                        display: flex;
                        .find{
                            flex: 1;
                            text-align: center;
                            p{
                                &:nth-of-type(1){
                                    font-size: 0.5rem;
                                    color: #eeb63e;    
                                }
                                &:nth-of-type(2){
                                    font-size: 0.32rem;    
                                }
                            }
                        }
                    }
                    &:nth-last-of-type(1){
                        text-align: center;
                        span{
                            display: inline-block;
                            background: #e2ac39;
                            padding: 0.1rem 0.25rem;
                            color: #fff;
                            border-radius: 0.25rem;
                        }
                    }
                }
            }
        }
        .loan-type{
            display: flex;
            li{
                border-right: 1px solid #e6e6e6;
                text-align: center;
                &:nth-last-of-type(1){
                    border-right: none;
                }
                img{
                    width: 80%;
                }
                .name{
                    font-size: 0.45rem;
                    font-weight: bold;
                    margin-bottom: 0.16rem;
                }
                .n1{
                    color: #ff9d3e;
                }
                .n2{
                    color: #03a484;
                }
                .n3{
                    color: #3e91ee;
                }
                .content{
                    border-radius: 0.25rem;
                    background: #f5f4f4;
                    display: inline-block;
                    color: #4f4f4f;
                    padding: 0.06rem 0.2rem;
                    margin-bottom: 0.16rem;
                }
                .pic{
                    height: 2.6rem;
                }
                span{
                    display: inline-block;
                    background: #e2ac39;
                    padding: 0.1rem 0.25rem;
                    color: #fff;
                    border-radius: 0.25rem;
                }
            }
        }
        .insurance-list{
            overflow: hidden;
            a{
                display: block;
                float: left;
                width: 30%;
                margin: 0 0.13rem;
                :nth-of-type(3n){
                    margin-right: 0;
                }
            }
            img{
                width: 100%;
                border-radius: 0.25rem;
            }
        }
        .elite-list{
            overflow-x: auto;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
            white-space: nowrap;
            li{
                width: 33%;
                margin-right: 0.3rem;
                text-align: center;
                display: inline-block;
                img{
                    width: 100%;
                    border-top-left-radius: 0.25rem;
                    border-top-right-radius: 0.25rem;
                }
                .name{
                    margin: 0.05rem 0;
                    color: #e2a92f;
                    font-weight: bold;
                    font-size: 0.45rem;
                }
                .inst{
                    color: #000;
                    font-size: 0.35rem;
                }
            }
        }
    }
    .m-ad{
        display: flex;
        margin-top: 0.4rem;
        a{
            margin-right: 0.4rem;
            &:nth-last-of-type(1){
                margin-right: 0;
            }
        }
        img{
            width: 100%;
        }
    }
    .finance-box-2{
        ul{
            display: flex;
            margin-top: 0.3rem;
        }
        li{
            margin-right: 0.3rem;
            &:nth-last-of-type(1){
                margin-right: 0;
            }
            img{
                width: 100%;
                border-top-left-radius: 0.25rem;
                border-top-right-radius: 0.25rem;
            }
            .pic{
                position: relative;
            }
            .play{
                position: absolute;
                display: block;
                width: 0.8rem;
                height: 0.8rem;
                background: url("../../assets/images/finance/play.png") no-repeat;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background-size: 100%;
            }
            .title{
                box-sizing: border-box;
                background: #f5f4f4;
                border-bottom-left-radius: 0.25rem;
                border-bottom-right-radius: 0.25rem;
                padding: 0.25rem;
            }
        }
    }
    .colmun-list{
        margin-top: 0.5rem;
        padding-bottom: 2rem;
        li{
            margin-top: 0.3rem;
            img{
                width: 100%;
            }
        }
    }
</style>